import StackTrace from "stacktrace-js";
import * as TraceKit from "tracekit";

window.ep = window.ep || {};

var EpLogger = function(){
    this.init = function(errorsLogUrl){
        if (this._isInitialized) {
            return;
        }

        this._errorsLogUrl = errorsLogUrl;
        this._isInitialized = true;
        this._traceKit = TraceKit.noConflict();

        if (process.env.NODE_ENV === 'production') {
            this._traceKit.report.subscribe(this._processError.bind(this));
        }
    };

    this.logError = function(error){
        this._sendToServer({
            error,
        });
    };

    this.logErrorWithExtendedStackTrace = function(error, errorInfo) {
        try {
            const stackTrace = {
                name: "logErrorWithExtendedStackTrace",
                message: error && error.message || null,
                errorInfo,
            };

            this._processError(stackTrace, false, error);
        } catch (error) { /* do nothing */ }
    };

    this._processError = function(stackTrace, _isWindowError, error){
        var stack = [],
            qs = {},
            context = [];

        if (stackTrace.stack && stackTrace.stack.length) {
            stackTrace.stack.forEach(function (frame) {
                stack.push({
                    'Location': 'line ' + frame.line + ', column ' + frame.column,
                    'FileName': frame.url,
                    'MethodName': frame.func || '[anonymous]'
                });
                context.push(frame.context);
            });
        }

        if (window.location.search && window.location.search.length > 1) {
            window.location.search.substring(1).split('&').forEach(function (segment) {
                var parts = segment.split('=');
                if (parts && parts.length == 2) {
                    qs[decodeURIComponent(parts[0])] = parts[1];
                }
            });
        }

        const errorDetails = {
            'OccurredOn': new Date().toISOString(),
            'Details': {
                'Error': {
                    'ClassName': stackTrace.name,
                    'Message': stackTrace.message || 'Script error.',
                    'StackTrace': stack,
                    'Context': stack.length === 1 ? context : undefined, // for currupted stack trace like 'line 0, column 0, func: ?'
                    'ErrorInfo': stackTrace.errorInfo,
                },
                'Environment': {
                    'UserLanguage': (navigator || {}).userLanguage,
                    'DocumentMode': document.documentMode,
                    'Browser': (navigator || {}).appCodeName,
                    'BrowserName': (navigator || {}).appName,
                    'BrowserVersion': (navigator || {}).appVersion,
                    'Platform': (navigator || {}).platform
                },
                'Request': {
                    'Url': document.location.href,
                    'QueryString': qs,
                    'Headers': {
                        'UserAgent': (navigator || {}).userAgent,
                        'Referer': document.referrer,
                        'Host': document.domain
                    }
                }
            }
        };

        let errorWithStackTrace = error;

        if (error.getExtendedJQueryErrorInfo) {
            let { jQueryErrorWithStackTrace, ...jQueryInfo } = error.getExtendedJQueryErrorInfo();
            errorWithStackTrace = jQueryErrorWithStackTrace;
            errorDetails.Details.Error.JQueryErrorInfo = {
                ...jQueryInfo,
                ...error
            };
        }

        StackTrace.fromError(errorWithStackTrace)
            .then(stackframes => {
                errorDetails.Details.Error.ExtendedStackTrace = stackframes.map(function(sf) {
                    return sf.toString();
                });
            }).catch(err => {
                errorDetails.Details.Error.ExtendedStackTrace = err.message;
                errorDetails.Details.Error.RawError = error;
            }).finally(() => this._sendToServer(errorDetails));
    };

    this._sendToServer = function(data){
        if(this._errorsLogUrl){
            var img = new Image(1,1);
            img.src = this._errorsLogUrl + '?errorInfo=' + encodeURIComponent(JSON.stringify(data, null, "\t"));
        }
    };
};

window.ep.EpLogger = new EpLogger();
if (!!window.ep.appRoot) { // for ResourcesLoaderFrame that doesn't set appRoot, see backend, ResourcesLoaderFrame.cshtml
    window.ep.EpLogger.init(`${window.ep.appRoot}ClientTrace/LogError`);
}
